import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'SZYBKI START TRENERA',
  description: 'Kompletna lista kontrolna przed każdym treningiem. Żeby każda sesja przebiegała bez zakłóceń.',
  value: '100 zł'
}, {
  number: 2,
  title: 'GIER RATUNKOWYCH',
  description: '30 gotowych gier ratunkowych na każdą nieoczekiwaną sytuację w treningu. Nigdy więcej chaosu.',
  value: '100 zł'
}, {
  number: 3,
  title: 'CHECKLISTA MISTRZA',
  description: 'Profesjonalny system kontroli jakości treningu. Wszystko pod kontrolą od pierwszego do ostatniego gwizdka.',
  value: '100 zł'
}, {
  number: 4,
  title: '50 KOMEND TRENERA',
  description: '50 gotowych komend i instrukcji które natychmiast organizują grupę i budują Twój autorytet na boisku.',
  value: '100 zł'
}, {
  number: 5,
  title: 'PLAN B NA DESZCZ, MAŁĄ GRUPĘ I CHAOS',
  description: 'Jasne rozwiązania na dzień gdy pogoda lub miejsce nie sprzyjają. Żadnego chaosu więcej.',
  value: '100 zł'
}, {
  number: 6,
  title: 'SZYBKIE ODPRAWY PRZED TRENINGIEM I MECZEM',
  description: 'Gotowe przemówienia które motywują i organizują drużynę w 3 minuty. Zawsze gotowy.',
  value: '100 zł'
}];
export function Bonuses() {
  return <section className="w-full bg-cream-alt py-12 md:py-20 px-4 md:px-6" data-id="element-50">
      <div className="max-w-6xl mx-auto" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-52">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-navy-primary mb-3 md:mb-4" data-id="element-53">
            6 specjalnych bonusów w zestawie
          </h2>
          <p className="text-xl md:text-2xl text-gold-accent font-bold" data-id="element-54">
            Łączna wartość bonusów: 600 zł
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-55">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-lg border border-gold-accent/20 flex flex-col h-full relative overflow-hidden" data-id="element-56">
              <div className="flex flex-col sm:flex-row items-start gap-4 h-full" data-id="element-57">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-gold-accent/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-58">
                  <Gift className="w-5 h-5 md:w-6 md:h-6 text-gold-accent" data-id="element-59" />
                </div>
                <div className="flex-1 flex flex-col h-full" data-id="element-60">
                  <div className="flex flex-wrap justify-between items-start gap-2 mb-2" data-id="element-61">
                    <h3 className="font-display font-bold text-navy-primary text-base md:text-lg pr-2" data-id="element-62">
                      BONUS {bonus.number} — {bonus.title}
                    </h3>
                    <span className="bg-gold-accent text-navy-primary px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-63">
                      {bonus.value} GRATIS
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-gray-700 leading-relaxed flex-grow" data-id="element-64">
                    {bonus.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}